export default {
	workers: {
		exportMenu: {
			caption: 'Export menu',
			type_interval: 'Podle intervalu',
			type_lastPays: 'Podle poslední výplaty',
			type_latestMonths: 'Podle poslední mesicu',
			typeLabel: 'Typ export'
		},
		debt: 'Povinnost',
		mark: 'Označit',
		subtracted: 'Odečtena',
		created_at: 'Vytvořeno u',
		hourly_rate: 'Hodinová sazba',
		number_hours: 'Počet hodin',
		pay: 'Platit',
		worker_home_address: 'pracovní domov adresa',
		document_number: 'číslo dokumentu',
		filename: 'Název souboru',
		fields: 'Pole',
		avatar: 'Avatar',
		title: 'Klíent',
		add_worker: 'Nový klíent',
		titul: 'Titul',
		id: 'Id',
		started_at: 'Od',
		ended_at: 'Do',
		firstname: 'Jméno',
		lastname: 'Příjmení',
		person_lastname: 'Osobní příjmení',
		person_firstname: 'Jméno osoby',
		person_birth_date: 'Datum narození',
		person_gender: 'Pohlaví osoby',
		gender: 'Pohlaví',
		male: 'mužský',
		female: 'ženský',
		actions: 'Akce',
		number: 'Number',
		type: 'Typ',
		issuer: 'Úřad, který doklad vydal',
		issued_at: 'Datum vydání',
		invalid_at: 'Platnost do',
		created: 'Vytvořeno',
		updated: 'Aktualizováno',
		work_permit_number: 'Číslo pracovního povolení',
		work_permit_date: 'Datum udělení povolení',
		cz_isco: 'Pozice (CZ-ISCO)',
		cz_nace: 'Zařazení (CZ-NACE)',
		job_start: 'Datum nástupu do zaměstnání',
		job_end: 'Datum ukončení zaměstnaní',
		job_form: 'Typ pracovního úvazku',
		salary_min: 'Minimální měsiční mzda',
		salary_max: 'Maximální měsiční mzda',
		sign_date: 'Datum podpisu smlouvy',
		first_job: 'První práce',
		active_job: 'Aktivní práce',
		search: 'Vyhledávání',
		worker: 'Klient',
		birth_date: 'Datum narození',
		citizenship: 'Státní občanství',
		civil_status: 'Rodinný stav',
		confirm_message_scan: 'Opravdu chcete odstranit doklad?',
		confirm_message_job: 'Opravdu chcete odstranit?',
		confirm_message_worker: 'Opravdu chcete odstranit?',
		confirm_message_pay: 'Opravdu chcete smazat plat?',
		upload_scan: 'Nahrát nový doklad',
		scan_types: 'Typ dokladu',
		scan_type: 'Typ dokladu',
		add_worker_skan: 'Přidat pracovní scan',
		number_document: 'Číslo dokumentu',
		job: 'Zaměstnání',
		employer: 'Zaměstnavatel',
		add_job: 'Přídat zaměstnání',
		parttime: 'Poloviční úvazek',
		fulltime: 'Plný úvazek',
		employer_required: 'Povinná informace',
		start_end_valid: 'Předpokládaná doba zaměstnání',
		merried: 'ženatý/vdaná',
		not_merried: 'Svobodný/á',
		save_general: 'Save General',
		edu_end: 'Konec',
		edu_start: 'Začátek',
		edu_institution_name: 'Název',
		edu_type: 'Typ vzdělání',
		education: 'Vzdělání',
		insurance_end_at: 'Datum ukončení pojištění',
		insurance_start_at: 'Datum zahájení pojištění',
		insurance_number: 'Číslo pojištěnce',
		insurance: 'Zdravotní pojištovná',
		birth_place: 'Místo narození',
		general: 'Všeobecné',
		contacts: 'Kontakty',
		deleting_contact: 'Podtvrdte smazání kontaktu',
		confirm_contact: 'Opravdu chcete smazat kontakt?',
		add_contact: 'Přidat kontakt',
		negative_salary: 'Plat je negativní',
		confirm_salary: 'Opravdu chcete platit plat {salary} na {workerName}',
		confirm_salary_title: 'Podtvrdit plat',
		confirm_pay_salary: 'Opravdu chcete platit plat?',
		pay_salary: 'Vyplatit peníze',
		to_pay: 'Platit',
		prepayment: {
			type_prepay: 'Záloha na mzdu',
			type_accommodation: 'Ubytování',
			type_fare: 'Doprava',
			type_premium: 'Prémie',
			confirm_payment_title_prepay: 'Podtvrdit vydání zálohy',
			confirm_payment_title_premium: 'Podtvrdit vydání prémie',
			confirm_payment_title_accommodation: 'Podtvrdit vydání ubytování',
			confirm_payment_title_fare: 'Podtvrdit vydání doprava',
			confirm_payment_prepay: 'Opravdu chcete vyplatit zálohu?',
			confirm_payment_accommodation: 'Opravdu chcete vyplatit ubytování?',
			confirm_payment_fare: 'Opravdu chcete vyplatit doprava?'
		},
		confirm_prepayment:
			'Opravdu chcete zaplatit předplacenou {amount} pracovníkovi {workerName} s komentářem {comment}',
		salary: 'Plat',
		name: 'Název',
		roles: 'Role',
		counts_day_hours: 'Počet Odpracovaných Hodin ',
		rate: 'Plat',
		rate_count_day: 'Plat za hodinu',
		payment: 'Platba',
		issue_payment: 'vydání platby',
		pay: 'Vyplatit',
		date_start: 'Od',
		date_end: 'Do',
		amount: 'Částka',
		comment: 'Komentař',
		add_comment: 'Přidat komentař',
		landlord: 'Ubytování',
		apartment_address: 'Adresa ubytování',
		room_number: 'Číslo pokoje',
		confirm_accommodation: 'Opravdu chcete odstranit ubytování',
		accommodation: 'Ubytovatel',
		accommodations: 'Ubytování',
		add_accommodation: 'Přidat ubytovatele',
		landlord_required: 'Pronajímatel je povinen',
		email: 'Email',
		main: 'Hlavní',
		user: 'Uživatel',
		date: 'Datum',
		sum_salary: 'Součet platu',
		sum_prepay: 'Součet záloh',
		employer_name: 'Zaměstnavatel',
		street_names: 'Ulice',
		landlord_name: 'Název',
		scan: 'Skenovat',
		rodni_chisla: 'Rodné číslo',
		passport_number: 'Číslo pasu',
		agency_name: 'Název agentury',
		export_finance_report: 'Finanční zpráva o exportu',
		address: 'Adresa',
		tab: {
			general: 'Obecná informace ',
			jobs: 'Zaměstnání',
			scans: 'Doklady',
			finance: 'Finance',
			comments: 'Komentař',
			history: 'Historie',
			accommodation: 'Ubytování'
		},
		filters: {
			type_label: 'Typ filtru',
			date_type_label: 'Typ data',
			byAgency: 'Typ data',
			byEmployer: 'Filtrování podle zaměstnavatele',
			byDateYear: 'Filtrovat podle roku',
			byDateMonth: 'Filtrování podle měsíce',
			byDateWeek: 'Filtrovat podle týdne',
			exportButton: 'Export',
			type_employer: 'Podle zaměstnavatele',
			type_agency: 'Agenturou',
			type_month: 'Podle měsíce',
			type_week: 'Týden'
		}
	},
	templates: {
		dialog_users_caption: 'Zadejte email',
		dialog_users_submit: 'Vytvořit',
		dialog_worker_caption: 'Vyberte uživatele',
		dialog_worker_user: 'Uživatel',
		download_file: 'Stahnout soubor',
		download_prev: 'Stahnout náhled',
		download_original: 'Stáhnout originál',
		available_fields: 'Volné pole',
		config: 'Konfigurace',
		loading: 'Načítání...',
		doc_templates: 'Šablony dokumentů',
		template: 'Šablona',
		templates: 'Šablony',
		save_changes: 'Uložít změny',
		you_sure: 'Jste si jistý?',
		select_template: 'Vyberte novou šablonu'
	},
	login: {
		login: 'Přihlásit se',
		email: 'Email',
		password: 'Heslo',
		login_form: 'Přihlásít se',
		logOut: 'Odhlásit se'
	},
	contacts: [
		{ type: 'vib', text: 'Viber' },
		{ type: 'tg', text: 'Telegram' },
		{ type: 'phone', text: 'Telefonní číslo' },
		{ type: 'skyp', text: 'Skype' },
		{ type: 'email', text: 'email' },
		{ type: 'bank_account_number', text: 'Číslo účtu' }
	],
	contacts_agency: [
		{ type: 'person_email', text: 'Osobní Email' },
		{ type: 'person_phone', text: 'Osobní Telefon' },
		{ type: 'office_email', text: 'Kancelář Email' },
		{ type: 'office_phone', text: 'Kancelář Telefon' }
	],
	navigation: {
		dashboard: 'Přístrojová deska\n',
		workers: 'Klienti',
		worker: 'Klient',
		employers: 'Zaměstnavatelé',
		employer: 'Zaměstnavatel',
		landlords: 'Ubytování',
		landlord: 'Ubytovatel',
		users: 'Uživatelé',
		user: 'Uživatel',
		login: 'Přihlásit se',
		finance_reports: 'Finanční reporty',
		user_finance_pays: 'Uživatelské finance',
		history: 'Historie',
		templates: 'Šablony',
		template: 'Šablona',
		settings: 'Nastavení',
		agencies: 'Agentury',
		agency: 'Agentura',
		personal_finance: 'Osobní finance',
		database: 'Databáze',
		settings_title: 'Nastavení',
		not_found: 'Nenalezeno'
	},
	payments_types: {
		type_salary: 'Plat',
		type_prepay: 'Záloha',
		type_debt: 'Dluh',
		type_accommodation: 'Ubytování',
		type_fare: 'Doprava',
		type_premium: 'Prémie',
		type_zp: 'Zdravotni pojisteni',
	},
	personal_finance: {
		show_personal_finance: 'Zobrazit osobní finance',
		output: 'Zálohy',
		debt: 'Dluh',
		premium: 'Prémie',
		input: 'Příjmy',
		pay: 'Výplaty',
		workers_pay: 'Pracovník platí',
		pay_accommodation: 'Ubytování',
		pay_fare: 'Doprava',
		add_input_button: 'Přidat',
		add_output_button: 'Přidat',
		transfer_button: 'Převod',
		dialog_caption_input: 'Příjem',
		dialog_caption_output: 'Výdej',
		amount: 'Částka',
		comment: 'Komentář',
		confirm_message_pay: 'Opravdu chcete smazat finance?',
		finance: 'finance',
		transfer: 'Převod',
		balance: 'Zůstatek',
		balance_by_period: 'Zůstatek za období',
		prepay_users: 'Předplatit uživatel',
		transfer_user_name: 'Uživatel',
		user_name: 'Jméno',
		id: 'Id',
		created_at: 'Vytvořeno',
		actions: 'Akce',
		category: 'Kategorie',
	},
	payment_category: {
		caption: "Platební kategorie",
	},
	employers: {
		header: 'Informace o zaměstnavateli',
		employers: 'Zaměstnavatelé',
		employer: 'Zaměstnavatel',
		name: 'Název',
		ico: 'IČ',
		dic: 'DIČ',
		person_titul1: 'Titul před jménem',
		person_titul2: 'Titul za jménem',
		person_rodnyChisla: 'Rodní číslo',
		save_employer: 'Uložit zaměstnavatele',
		add_employer: 'Přidat zaměstnavatele'
	},
	history: {
		history: 'Historie',
		new_field: 'Pole s názvem',
		old: 'Před změnou',
		new: 'Po změně',
		employer_id: 'Identifikátor zaměstnavatele'
	},
	landlords: {
		header: "Informace o pronajímateli",
		landlords: 'Ubytování',
		landlord: 'Ubytovatel',
		titul_first: 'Titul před jménem',
		titul_second: 'Titul za jménem',
		person_document_id: 'Číslo  občanského průkazu',
		person_document_issuer: 'Úřad, který doklad vydal',
		save_landlord: 'Uložit ubytovatele',
		add_landlord: 'Přidat ubytovatele'
	},
	address: {
		office_address: 'Sídlo firmy',
		work_address: 'Adresa výkonu práce',
		apartment_address: 'Adresa ubytování',
		person_address: 'Adresa v zemi trvalého pobytu',
		landlord_apartment_address: 'Adresa domácího bytu',
		landlord_person_address: 'Domácí adresa majitele',
		employer_office_address: 'Adresa kanceláře zaměstnavatele',
		employer_work_address: 'Pracovní adresa zaměstnavatele',
		user_home_address: 'Domovní adresa',
		agency_address: 'Sídlo firmy',
		work_address_id: 'ID pracovní adresy',
		actions: 'Akce',
		country: 'Země',
		district: 'Kraj',
		region: 'Okres',
		city: 'Město',
		index: 'PSČ',
		smirovaci: 'Směrovací číslo',
		street: 'Ulicé',
		building_number: 'Číslo',
		address: 'Adresa',
		add_address: 'Přidat adresu',
		confirm_address: 'Opravdu chcete odstranit adresu?'
	},
	user: {
		header: "Uživatelské informace",
		users: 'Uživatele',
		user: 'Uživatel',
		passport: 'Číslo občanského průkazu',
		created_at: 'Vytvořeno',
		updated_at: 'Aktualizováno',
		add_user: 'Přidat uživatele',
		new_password: 'Nové Heslo',
		repeat_password: 'Zopakovat Heslo',
		password: 'Heslo',
		change_password: 'Změna Hesla',
		password_not_match: 'Hesla se neshodují',
		confirm_password: 'Opravdu chcete změnit heslo?',
		confirm_password_title: 'Potvrďte Změnu Hesla',
		save_user: 'Uložit uživatele'
	},
	roles: {
		admin: 'Správce',
		manager: 'Manažer',
		can_prepay: 'může předplatit'
	},
	common: {
		email: 'Email',
		type_contact: 'Zadejte kontakt',
		template_name: 'Název',
		site_title: 'PPA online',
		site_name: 'PPA&nbsp;<span class="font-weight-light">online</span>',
		close: 'Zavřít',
		save: 'Uložit',
		yes: 'Ano',
		no: 'Ne',
		delete: 'Vymazat',
		edit: 'Upravit',
		download: 'Stahnout',
		confirm: 'Potvrdit',
		cancel: 'Zrušit',
		ok: 'OK',
		value: 'Hodnota',
		name: 'Jméno Přijmení',
		comment: 'Komentař',
		sum: 'Součet',
		text: 'Text',
		add: 'Přidat',
		all: 'Všechno',
		no_result: 'Vaše hledání "{search}" nenalezlo žádné výsledky.',
		item: 'Položka',
		add_new: 'Přidat nový',
		not_found: 'Nenalezeno',
		enabled: 'Umožnit',
		disabled: 'Zakázat',
		no_internet: 'ŽÁDNÉ INTERNETOVÉ PŘIPOJENÍ',
		created: 'Vytvořit',
		updated: 'Aktualizovát',
		deleted: 'Smazat',
		main_search: 'Vyhledejte své oblíbené',
		email_required: 'Je vyžadován e-mail',
		email_valid: 'E-mail musí být platný',
		password_required: 'Heslo je vyžadováno',
		not_found_title: 'Ach ne, smůlu!',
		not_found_text:
			'Stránka, kterou hledáte, mohla být smazána nebo nikdy neexistovala.',
		field_required: 'Políčko je vyžadováno',
		confirm_message_avatar: 'Opravdu chcete odstranit avatar?',
		confirm_message_comment: 'Opravdu chcete smazat komentář?',
		upload: 'Nahrát',
		insurance_company: 'Pojišťovna',
		history_dates: 'Pro aktuální data není žádná historie',
		find: 'Nalézt',
		jobs: 'Zaměstnání',
		none: 'Žádný',
		filter_by_agency: 'Hledat podle agentury',
		gender_male: 'muž',
		gender_female: 'žena'
	},
	notifications: {
		saved: '{type} úspěšně uloženo',
		added: '{type} úspěšně pridano',
		updated: '{type} úspěšně aktualizovano',
		deleted: '{type} úspěšně smazano',
		upload: '{type} úspěšně nahrano',
		created: '{type} úspěšně vytvořeno',
		changed: '{type} úspěšně změněno',
		server_error: 'Chyba serveru - načíst stránku znovu',
		client_error: 'Chyba klienta - načíst stránku znovu  ',
		no_connection: 'Ne připojení k internetu‘'
	},
	agencies: {
		header: "Informace agentury",
		person_firstname: 'Jméno osoby',
		person_lastname: 'Příjmení',
		agencies: 'Agentury',
		add_agency: 'Přidat agenturu',
		id: 'Id',
		name: 'Název',
		ico: 'IČ',
		dic: 'DIČ',
		company_number: 'Číslo sociálního zabezpečení',
		actions: 'Akce',
		agency: 'Agentura',
		social_security_number: 'Variabilní symbol',
		spisova_znachka: 'Spisova Znachka',
		mpsv: 'MPSV',
		save_agency: 'Uložit agenturu',
		notAgency: '<žádná agentura>'
	},
	reports: {
		all: 'Všichni',
		users: 'Kdo vydal',
		workers: 'Klienti'
	},
	$vuetify: {
		dataIterator: {
			pageText: '{0}-{1} z {2}',
			rowsPerPageAll: 'Všechno',
		},
		dataTable: {
			rowsPerPageText: 'Řádky na stránku:',
		},
		noDataText: 'Data nejsou k dispozici'
	}
}
